module.exports = __webpack_public_path__ + "static/21-ING-GINEBRA.77e8407c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/beverages/21-ING-GINEBRA.png
// module id = 617
// module chunks = 35783957827783